// extracted by mini-css-extract-plugin
module.exports = {"copilotMainContainer":"CopilotBot_copilotMainContainer__7gw8Y","copilotHiddenContainer":"CopilotBot_copilotHiddenContainer__gvbZQ"};